import { Box } from "@mui/material";
import React from "react";
import styles from "./style.module.css";

const Image = ({ image, label }) => {
  return (
    <Box className={styles.image}>
      <Box
        className={styles.primaryImg}
        style={{
          backgroundImage: `url(${image})`,
        }}
      ></Box>
    </Box>
  );
};

export default Image;
